import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { authRef } from '../reference';

export default class Landing extends Component {
  componentDidMount() {
    authRef.onAuthStateChanged(user => {
      if (user) {
        browserHistory.push('/home');
      }
    });
  }

  render() {
    return (
      <div className="Landing">
        <h1>Refresh Works</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Landing.js